import type { IconSvgObject } from './types';

const ChartSplineIcon: IconSvgObject = [
  ["path", { d: "M20 9.75C19.6616 7.59375 18.5 6 16.8577 6C15.2154 6 14 8.23875 14 11C14 13.7613 13 16 11.1423 16C9.5 16 8.33949 14.4081 8 12.25", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 21H10C6.70017 21 5.05025 21 4.02513 19.9749C3 18.9497 3 17.2998 3 14V3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartSplineIcon;
